import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
//
// Copyright 2020 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React, { useEffect, useState } from "react";

/**
 * Name of active profile.
 */
var profile = {};
/**
 * Listeners which will be called any time the configuration profile changes.
 */
var listeners = [];
function get() {
  return profile;
}
function set(p) {
  if (profile !== p) {
    profile = p;
    listeners.forEach(function (listener) {
      return listener(profile);
    });
  }
}
function addListener(listener) {
  listeners.push(listener);
}
function removeListener(listener) {
  listeners = listeners.filter(function (aListener) {
    return aListener !== listener;
  });
}

/**
 * Hook used to access and change active configuration profile.
 */
export function useConfigProfile() {
  var _useState = useState(get()),
    _useState2 = _slicedToArray(_useState, 2),
    configProfile = _useState2[0],
    setConfigProfile = _useState2[1];

  /**
   * Reset the listener anytime the setter method changes.
   */
  useEffect(function () {
    addListener(setConfigProfile);
    return function () {
      removeListener(setConfigProfile);
    };
  }, [setConfigProfile]);

  /**
   * Update the cached profile anytime it's changed.
   */
  useEffect(function () {
    set(configProfile);
  }, [configProfile]);
  return [configProfile, setConfigProfile];
}